<!-- 
    З планів:
        2. Планую зробити блочки, як готові патерни блоків різних (не просто окремо додавати h2, умовний, та за ним список, а одразу готову комбінацію)
        3. Зробити зміст з якорями
        4. Зробити другий режим (Rows), котрий буде всі елементи давати список, а не графічно
        5. Копіювати елемент
        6. Змінення елементів місцями
        7. Видалення елементів
        8. Дока в пдф
-->

<template>
    <div 
        class="containter"
        style="margin-bottom: 20px; margin-left: var(--vz-gutter-x, 0.75rem);"
    >
        <div class="row"
            style="min-width: 300px;"
        >
            <Multiselect
                mode="tags"
                :searchable="true"
                :create-option="false"
                :options="projectList"
            />
        </div>
    </div>
    <div class="container_custom">
        <div class="blocksMenu">
            <div class="blocksMenu__chooseMode">
                <!-- <span style="font-size: 24px;">Parts</span> -->
                <div 
                    class="blocksMenu__chooseMode__switcher"
                    style="margin-top: 10px;"
                >
                    <span>Parts</span>
                    <div 
                        class="form-check form-switch"
                        style="padding-left: 50px"
                    >
                        <input
                            v-model="this.mode"
                            class="form-check-input" 
                            type="checkbox" 
                            id="flexSwitchCheckDefault"
                        >
                        <!-- <label class="form-check-label" for="flexSwitchCheckDefault">Default switch checkbox input</label> -->
                    </div>
                    <span>Blocks</span>
                </div>  
            </div>
            <hr />
            <div class="blocksMenu__blockMenu">
                <ul v-if="this.mode === false">
                    <li 
                        class="sections_menu"
                        v-for="(item, index) in sections"
                        :key="index"
                    >
                        <ul 
                            v-if="item.childrens.length > 0"
                            class="sections_menu_subMenu"
                        >
                            <li
                                v-for="(item, index) in item.childrens"
                                :key="index"
                                class="sections_menu_subMenu__items"
                            >
                                {{ items }}
                            </li>
                        </ul>
                    </li>
                </ul>
                <ul class="list_blockMode" v-else>
                    <li
                        v-for="item in sourceItems"
                        :key="item.id"
                        class="item blockMode"
                        draggable="true"
                        @dragstart="onDragStart(item)"
                        @dragend="onDragEnd"
                    >
                        <!-- <template v-for="items in item"> -->
                            <div class="item-block">
                                <div class="item-block__icon">
                                    <i :class="item.icon"></i>
                                </div>
                            </div>
                        <!-- </template> -->
                    </li>
                </ul>
            </div>
        </div>
        <div class="workspace">
            <div class="workspace__editor">
                <div  style="display: grid; align-items: center; grid-template-rows: 1fr;">
                    <h1 
                        class="doc_title"
                        style="word-break: break-all; grid-row-start: 1" 
                        contenteditable="true"
                        @keydown.enter.prevent="this.saveTitle($event)"
                        @blur="this.saveTitle($event)"
                    >
                        {{ this.form.title }}
                    </h1>
                    
                    <!-- Кнопка "Додати" для малих екранів -->
                    <button 
                        type="button" 
                        class="btn btn-success btn-icon waves-effect " 
                        data-bs-toggle="dropdown" 
                        aria-expanded="false"
                        style="justify-self: end; grid-row-start: 1; align-self: center;"
                        @click="addDoc"
                    >
                        <i class="ri-save-line"></i>
                    </button>
                </div>
                
                <hr />

                <div 
                    class="workspace__editor__dropArea"
                >
                    <ul style="padding: 0;word-break: break-all;max-width: 100%;">
                        <template v-for="(item, index) in withDropZones" :key="item.id || `dropzone-${index}`">
                            <li
                                v-if="!item.isDropZone"
                                class="drop-item"
                                style="
                                    display: flex; 
                                    gap: 10px; 
                                    max-width: 100%;
                                    align-items: center;
                                "
                                @mouseover="this.showElementMenu[index] = true"
                                @mouseleave="this.showElementMenu[index] = false"
                            >
                                <div 
                                    style="
                                        display: flex; 
                                        justify-content: center; 
                                        align-items: center;
                                        min-width: 50px !important;
                                        min-height: 25px;
                                    "
                                    class="additionalMenu" 
                                >
                                    <button 
                                        type="button" 
                                        class="btn btn-ghost-danger btn-icon btn-sm fs-16"
                                        style="height: 25px; width: 100%"
                                        @click="this.deleteItem(item)"
                                        v-show="this.showElementMenu[index] === true"
                                    >
                                        <i class="ri-delete-bin-line"></i>
                                    </button>

                                    <button 
                                        type="button" 
                                        class="btn btn-ghost-secondary btn-icon btn-sm fs-16"
                                        style="height: 25px; width: 100%"
                                        
                                        v-show="this.showElementMenu[index] === true"
                                    >
                                        <i class="ri-menu-line"></i>
                                    </button>
                                </div>
                                <!-- Якщо у нас p -->
                                <template 
                                    v-if="!item.isDropZone && (
                                            (
                                                item.tag === 'p' || 
                                                (
                                                    item.tag !== 'h1' && 
                                                    item.tag !== 'h2' &&
                                                    item.tag.split('')[0] === 'h' &&
                                                    item.tag != 'hr' 
                                                )
                                            )
                                        )
                                    "
                                >
                                    <span
                                        contenteditable="true" 
                                        :style="(this.searchStyle(item))"
                                        style="width: 100%;"
                                        @input="this.saveInBuffer(item, $event)"
                                        @blur="this.saveChanges(item, index)"
                                        @keypress.enter.prevent="this.addBlock($event, item)"
                                    >
                                        {{ item.text }}
                                    </span>
                                </template>

                                <!-- Якщо у нас h1/h2 -->
                                <template 
                                    v-if="!item.isDropZone && (
                                            (
                                                item.tag === 'h1' || 
                                                item.tag === 'h2'
                                            )
                                        )
                                    "
                                >
                                    <span 
                                        contenteditable="true"
                                        style="width: 100%;" 
                                        :style="(this.searchStyle(item))"
                                        @input="this.saveInBuffer(item, $event)"
                                        @blur="this.saveChanges(item, index)"
                                        :id="item.uuid"
                                        @keypress.enter.prevent="this.addBlock($event, item)"
                                    >
                                        {{ item.text }}
                                    </span>
                                </template>

                                <!-- Якщо у нас hr -->
                                <template 
                                    v-if="!item.isDropZone && (
                                            item.tag === 'hr'
                                        )
                                    "
                                >   
                                    <hr 
                                        :style="this.searchStyle(item)"
                                    />
                                </template>

                                <!-- Якщо у нас ul or ol -->
                                <template 
                                    v-if="!item.isDropZone && (
                                            item.tag === 'ul' || item.tag === 'ol'
                                        )
                                    "
                                >
                                    <template v-if="item.tag === 'ul'">
                                        <ul 
                                            :style="this.searchStyle(item)"
                                            style="width: 100%;"
                                        >
                                            <li 
                                                v-for="text, idx in item.text"
                                                :key="idx"
                                        style="width: 100%;"
                                                class="li_focusVisisble"
                                                @input="this.saveInBuffer(item, $event)"
                                                @keydown.enter="addPoint($event, item, idx)"
                                                @keypress.enter.prevent
                                                @blur="this.saveChanges(item, index, idx)"
                                                @keydown.backspace="deletePoint(item, idx, text)"
                                                @focus="updateContent($event)"
                                                contenteditable="true"
                                                :style="this.content.length === 0 && item.text.length === 0 ? 'min-width: 100%; height: 100%; display: block; background-color: #efefef' : this.searchStyle(item)"
                                            >
                                                {{ text }}
                                            </li>
                                        </ul>
                                    </template>
                                    <template v-if="item.tag === 'ol'">
                                        <ol 
                                            :style="this.searchStyle(item)"
                                            style="width: 100%;"
                                        >
                                            <li 
                                                v-for="text, idx in item.text"
                                                style="width: 100%;"
                                                :key="idx"
                                                class="li_focusVisisble"
                                                @input="this.saveInBuffer(item, $event)"
                                                @keydown.enter="addPoint($event, item, idx)"
                                                @keypress.enter.prevent
                                                @blur="this.saveChanges(item, index, idx)"
                                                @keydown.backspace="deletePoint(item, idx, text)"
                                                @focus="updateContent($event)"
                                                contenteditable="true"
                                                :style="this.content.length === 0 && item.text.length === 0 ? 'min-width: 100%; height: 100%; display: block; background-color: #efefef' : this.searchStyle(item)"
                                            >
                                                {{ text }}
                                            </li>
                                        </ol>
                                    </template>
                                </template>

                                <template
                                    v-if="!item.isDropZone && (
                                            item.tag === 'code' &&
                                            item.name === 'code'
                                        )
                                    "
                                >
                                    <code 
                                        :style="this.searchStyle(item)"
                                        style="width: 100%;"
                                        contenteditable="true"
                                        @focus="this.content = item.text"
                                        @input="this.saveInBuffer(item, $event)"
                                        @blur="this.saveChanges(item, index)"
                                        @keydown="this.handleInput($event, 'code')"
                                        v-html="item.text"
                                    >
                                    </code>
                                </template>

                                <template
                                    v-if="!item.isDropZone && (
                                            item.tag === 'code' &&
                                            item.name === 'terminal'
                                        )
                                    "
                                >
                                    <code 
                                        :style="this.searchStyle(item)"
                                        contenteditable="true"
                                        @focus="this.content = item.text"
                                        @input="this.saveInBuffer(item, $event)"
                                        @blur="this.saveChanges(item, index)"
                                        @keydown="this.handleInput($event, 'terminal')"
                                        v-html="item.text"
                                    >
                                    </code>
                                </template>

                                <template
                                    v-if="!item.isDropZone && (
                                            item.tag === 'article'
                                        )
                                    "
                                >
                                    <div 
                                        :style="this.searchStyle(item)"
                                        class="note"
                                    >
                                        <p class="note__title">
                                            <i class="ri-sticky-note-2-line"></i>
                                            Нотатка
                                        </p>
                                        <p
                                            class="note__text"
                                            style="width: 100%;"
                                            contenteditable="true"
                                            @input="this.saveInBuffer(item, $event)"
                                            @blur="this.saveChanges(item, index)"
                                        >
                                            {{ item.text }}
                                        </p>
                                    </div>
                                </template>

                                <template 
                                    v-if="!item.isDropZone && (
                                        item.tag === 'a'
                                    )"
                                >
                                    <a
                                        style="display: block; width: 100%;"
                                        :style="this.searchStyle(item)"
                                        contenteditable="true"
                                        @click="this.showLinkMenu(item, $event)"
                                        @input="this.saveInBuffer(item, $event)"
                                        @blur="this.saveChanges(item, index)"
                                        :href="item.text.url"
                                    >
                                        {{ item.text.content }}
                                    </a>
                                </template>

                                <template 
                                    v-if="!item.isDropZone && (
                                        item.tag === 'table'
                                    )"
                                >

                                    <div class="table_block" style="position: relative;">
                                        <table
                                            :style="this.searchStyle(item)"
                                            style="margin-bottom: 50px; table-layout: fixed;"
                                        >
                                            <thead>
                                                <tr>
                                                    <th 
                                                        v-for="(header, idx) in item.text.headers" 
                                                        :key="idx" 
                                                        style="border: 1px solid black; word-break: break-all;"
                                                        contenteditable="true"
                                                        @input="this.saveInBuffer(item, $event)"
                                                        @blur="this.saveChangesForTable(item, 'header', idx)"
                                                    >
                                                        {{ header }}
                                                    </th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr 
                                                    v-for="(row, idx) in item.text.rows" 
                                                    :key="idx"
                                                >
                                                    <td 
                                                        v-for="(cell, k) in row" 
                                                        :key="k" 
                                                        style="border: 1px solid black; word-break: break-all;"
                                                        contenteditable="true"
                                                        @input="this.saveInBuffer(item, $event)"
                                                        @blur="this.saveChangesForTable(item, idx, k)"
                                                    >
                                                        {{ cell }}
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                        <button 
                                            class="tableButton column"
                                            @click="addColumn(item)"
                                        >
                                            +
                                        </button>
                                        <button 
                                            class="tableButton row"
                                            @click="addRow(item)"
                                        >
                                            +
                                        </button>
                                    </div>
                                </template>
                            </li>

                            <li 
                                v-if="item.isDropZone && isDragging"
                                @dragover.prevent="onDragOver(index)"
                                @drop="onDrop(index)"
                                :class="{ 'drop-zone': item.isDropZone, hidden: item.isDropZone && !isDragging }"
                            >
                            </li>
                        </template>
                    </ul>
                </div>  
            </div>
        </div>
        <div class="content">
            <ul>
                <li v-for="item, index in this.contents">
                    <a :href="'/create/' + items?.uuid">{{ item.text }}</a>
                    <template 
                        v-if="item?.subItems.length > 0"
                    >
                        <ul>
                            <li v-for="items in item.subItems">
                                <a :href="'/create/' + items?.uuid">{{ items.text }}</a>
                            </li>
                        </ul>
                    </template>
                </li>
            </ul>
        </div>
    </div>


    <div 
        v-show="this.linkMenu === true" 
        :style="{left: this.contextMenu.x + 'px', top: this.contextMenu.y + 'px'}" 
        class="link_menu"
    >
        <div class="link_menu__header">
            <button 
                class="btn-close"
                @click="this.linkMenus[index] === false"
            >

            </button>
        </div>
        <div class="link_menu__body">
            <div class="input-group mb-3">
                <input  
                    type="text" 
                    class="form-control" 
                    placeholder="Link" 
                    aria-label="Link" 
                    aria-describedby="basic-addon2"
                    style="height: 38px;"
                    v-model="this.linkBuffer"
                >
                <div class="input-group-append" style="height: 38px;">
                    <span 
                        class="input-group-text" 
                        id="basic-addon2"
                        style="height: 38px; cursor: pointer"
                        @click="this.saveUrl()"
                    >
                        <i class='bx bx-subdirectory-left'></i>
                    </span>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { apiServe } from '../newtickets/view/formright/clientnumber.vue';
import { useRouter } from 'vue-router';
import Multiselect from "@vueform/multiselect";
import "@vueform/multiselect/themes/default.css";

const router = useRouter();

export default {
    data() {
        return {
            showElementMenu: [],
            projectList: [],
            form: {
                title: 'Title',
                documentation: [],
                projectId: []
            },
            sourceItems: [
                { 
                    name: "h1", 
                    tag: "h1",
                    text: "",
                    icon: "ri-h-1"
                },
                { 
                    name: "h2", 
                    tag: "h2",
                    text: "",
                    icon: "ri-h-2"
                },
                { 
                    name: "h3", 
                    tag: "h3",
                    text: "",
                    icon: "ri-h-3"
                },
                { 
                    name: "h4", 
                    tag: "h4",
                    text: "",
                    icon: "ri-h-4"
                },
                { 
                    name: "h5", 
                    tag: "h5",
                    text: "",
                    icon: "ri-h-5"
                },
                { 
                    name: "h6", 
                    tag: "h6",
                    text: "",
                    icon: "ri-h-6"
                },
                { 
                    name: "p", 
                    tag: "p",
                    text: "",
                    icon: "bx bxl-pinterest-alt"
                },  
                { 
                    name: "hr", 
                    tag: "hr",
                    icon: "ri-separator"
                },  
                {
                    name: "list-unordered", 
                    tag: "ul",
                    icon: "ri-list-unordered",
                    text: [''],
                },  
                {
                    name: "list-ordered", 
                    tag: "ol",
                    icon: "ri-list-ordered",
                    text: [''],
                },  
                {
                    name: "code", 
                    tag: "code",
                    icon: "ri-code-line",
                    text: '',
                },  
                {
                    name: "note", 
                    tag: "article",
                    icon: "ri-sticky-note-2-line",
                    text: '',
                },  
                {
                    name: "terminal", 
                    tag: "code",
                    icon: "ri-terminal-box-line",
                    text: '$\u00A0',
                },  
                {
                    name: "link", 
                    tag: "a",
                    icon: "ri-link",
                    text: {
                        content: '',
                        url: '',
                    },
                },  
                {
                    name: "table", 
                    tag: "table",
                    icon: "ri-table-line",
                    text: {
                        headers: ['head1', 'head2'],
                        rows: [
                            ['1', '2'],
                            ['1', '2']
                        ]
                    },
                }
            ],
            targetItems: [], // Елементи в зоні цілі
            draggedItem: null, // Перетягуваний елемент
            isDragging: false,
            content: '',
            mode: true,
            lastItemIdx: null,
            linkMenu: false,
            contextMenu: {
                x: 0,
                y: 0
            },
            linkBuffer: ''
        }
    },
    props: ['section'],
    created() {
        this.targetItems.push({
            name: "p", 
            tag: "p",
            text: "",
            icon: "bx bxl-pinterest-alt",
            uuid: this.generateId()
        })
    },
    mounted() {  
        // Створюємо MutationObserver
        const observer = new MutationObserver((mutationsList) => {
            for (const mutation of mutationsList) {
            if (mutation.type === "childList") {
                console.log(mutation.addedNodes)
                // Виявлено додавання нового елемента
                if (mutation.addedNodes.length > 0) {
                    mutation.addedNodes.forEach((node) => {
                        if (node.tagName === "LI") {
                            node.focus()
                        } else if(this.lastItemIdx != null){
                            console.log(this.lastItemIdx)
                            console.log(document.querySelectorAll('.drop-item')[this.lastItemIdx + 1].childNodes)
                            document.querySelectorAll('.drop-item')[this.lastItemIdx + 1].childNodes.forEach((el,index) => {
                                if(el.nodeName === "span") {
                                    document.querySelectorAll('.drop-item')[this.lastItemIdx + 1].childNodes[index].focus()
                                }
                            })
                            this.lastItemIdx = null
                        }
                    });
                }
            }
            }
        });

        const workSpace = document.querySelector('.workspace__editor__dropArea')

        // Налаштовуємо спостереження
        observer.observe(workSpace, {
            childList: true, // Спостерігаємо за додаванням або видаленням дочірніх елементів
            subtree: true,  // Не спостерігаємо за піддеревами
        });
    },
    components: {
        Multiselect
    },
    computed: {
        withDropZones() {
            // Додаємо зони скидання між елементами
            const zones = [];
            this.linkMenus = []
            this.targetItems.forEach((item, index) => {
                // додаємо "прапорці" для менюшок лінків
                if(item.tag === 'a') {
                    this.linkMenus.push(false)
                }
                this.showElementMenu.push(false)
                zones.push({ isDropZone: true, id: `dropzone-${this.generateId()}` });
                item["id"] = this.generateId()
                zones.push(item);
            });
            zones.push({ isDropZone: true, id: `dropzone-end` });
            return zones;
        },
        contents() {
            let content = []
            this.targetItems.forEach(el => {
                if(el.tag === 'h1') {
                    content.push({ 
                        tag: 'h1',
                        text: el.text, 
                        uuid: el.uuid, 
                        subItems: [] 
                    })
                } else if(el.tag === 'h2') {
                    content[content.length - 1].subItems.push({
                        tag: 'h2',
                        text: el.text,
                        uuid: el.uuid,
                    })
                }
            })

            return content
        }
    },
    methods: {
        addBlock(event, item) {
            console.log(event, item)
            let idx = this.targetItems.findIndex(el => el.id === item.id)
            this.lastItemIdx = idx
            console.log(idx)
            this.targetItems.splice(
                idx+1, 0, {
                    name: "p", 
                    tag: "p",
                    text: "",
                    icon: "bx bxl-pinterest-alt",
                    uuid: this.generateId()
                }
            );

        },
        updateContent(event) {
            this.content = event.target.textContent
        },
        deleteItem(item) {
            const idx = this.targetItems.findIndex(el => el.id === item.id)
            this.targetItems.splice(idx, 1)
        },
        deletePoint(item, idx, text) {
            if(this.content.length === 0) {
                this.targetItems[this.targetItems.findIndex(el => el.id === item.id)].text.splice(idx, 1)

                if(item.text.length === 0) {
                    this.targetItems.splice(this.targetItems.findIndex(el => el.id === item.id), 1)
                }
            }
        },
        addDoc() {
            // Додавання доки в базу
            this.form.documentation = this.targetItems
            
            // Тут API
            apiServe.addDocumentation(this.form).then(result => {
                if(result.status === 'done') {
                    this.$toast.success(this.$t('success'))

                    router.push({ 
                        name: 'pages-list-open-notion', 
                        params: { id: `${result.data}` } }
                    );
                } else {
                    switch (result.error[0]) {
                        case "data not found":
                            this.$toast.error(this.$t('dataNotFound'))
                        break;
                    }
                }
            })
        },
        saveTitle(event) {
            this.form.title = event.target.textContent
            event.target.blur()
            this.content = ''
        },
        addColumn(item) {
            const idx = this.targetItems.findIndex(el => el.id === item.id)
            this.targetItems[idx].text['headers'].push(('head' + (this.targetItems[idx].text['headers'].length + 1)))
            this.targetItems[idx].text['rows'].forEach(el => {
                el.push(this.targetItems[idx].text['rows'].length)
            })
        },
        addRow(item) {
            const idx = this.targetItems.findIndex(el => el.id === item.id)
            let newRow = []
            this.targetItems[idx].text['rows'][0].forEach((el, index) => {
                newRow.push(index + 1)
            })

            this.targetItems[idx].text['rows'].push(newRow)  
        },
        saveUrl() {
            this.targetItems[this.lastItemIdx].text.url = this.linkBuffer
            this.linkBuffer = ''
            this.linkMenu = false
        },
        showLinkMenu(item, event) {
            this.lastItemIdx = this.targetItems.findIndex(el => el === item)
            this.linkBuffer = this.targetItems.find(el => el === item).text.url
            this.contextMenu.x = event.x
            this.contextMenu.y = event.y
            this.linkMenu = true
        },
        insertBr(element, type) {
            const selection = window.getSelection(); // Отримуємо виділення
            if (!selection.rangeCount) return; // Якщо немає виділення, виходимо

            const range = selection.getRangeAt(0); // Поточний діапазон виділення
            if (!element.contains(range.commonAncestorContainer)) return; // Перевіряємо, чи курсор у вказаному елементі

            // Створюємо новий HTML-елемент
            const newElement = document.createElement('br');
            let textNode;
            if(type === 'code') {
                textNode = document.createTextNode('\u200B')
            } else if(type === 'terminal') {
                textNode = document.createTextNode('$\u00A0')
            }

            // Вставляємо елемент у місце курсору
            range.insertNode(textNode)
            range.insertNode(newElement);

            // Переміщуємо курсор після вставленого елемента
            range.setStartAfter(textNode);
            range.setEndAfter(textNode);
            selection.removeAllRanges();
            selection.addRange(range);
        },
        // insertTagAtCursor(element, tagName, attributes = {}) {
        //     const selection = window.getSelection(); // Отримуємо виділення
        //     if (!selection.rangeCount) return; // Якщо немає виділення, виходимо

        //     const range = selection.getRangeAt(0); // Поточний діапазон виділення
        //     if (!element.contains(range.commonAncestorContainer)) return; // Перевіряємо, чи курсор у вказаному елементі

        //     // Створюємо новий HTML-елемент
        //     const newElement = document.createElement(tagName);

        //     // Додаємо атрибути до нового елемента
        //     for (const [key, value] of Object.entries(attributes)) {
        //         newElement.setAttribute(key, value);
        //     }

        //     // Додаємо вміст до нового елемента (може бути пустий)
        //     newElement.innerHTML = attributes.content || "";

        //     // Вставляємо елемент у місце курсору
        //     range.insertNode(textNode)
        //     range.insertNode(newElement);

        //     // Переміщуємо курсор після вставленого елемента
        //     range.setStartAfter(textNode);
        //     range.setEndAfter(textNode);
        //     selection.removeAllRanges();
        //     selection.addRange(range);
        // }, 
        insertSpacesAtCursor(element, spaceCount = 4) {
            const selection = window.getSelection(); // Отримуємо виділення
            if (!selection.rangeCount) return; // Якщо немає виділення, виходимо

            const range = selection.getRangeAt(0); // Поточний діапазон виділення
            if (!element.contains(range.commonAncestorContainer)) return; // Перевіряємо, чи курсор у потрібному елементі

            // Генеруємо пробіли
            const spaces = "\u00A0".repeat(spaceCount); // Використовуємо `&nbsp;` (незламний пробіл)
            const spaceNode = document.createTextNode(spaces);

            // Вставляємо пробіли у поточну позицію курсору
            range.insertNode(spaceNode);

            // Переміщуємо курсор за пробіли
            range.setStartAfter(spaceNode);
            range.setEndAfter(spaceNode);
            selection.removeAllRanges();
            selection.addRange(range);
            },
        handleInput(event, type) {
            
            if(event.key === "Tab" || event.key === "Enter") {
                event.preventDefault()

                switch (event.key) {
                    case "Tab":
                        this.insertSpacesAtCursor(
                            event.srcElement
                        )
                    break;
                    case "Enter":
                        this.insertBr(
                            event.srcElement, 
                            type
                        )
                    break;
                }
            }
        },
        addPoint(event, item, index) {
            if(event.repeat) return
            event.preventDefault()
            this.targetItems.find(el => el.id === item.id).text[index] = this.content
            this.targetItems.find(el => el.id === item.id).text.push('')
            this.content = ''
        },
        saveChanges(item, index, listidx) {
            if(this.content != '') {
                if(item.tag === 'ol' || item.tag === 'ul') {
                    if(index) {
                        this.targetItems.find(el => el.id === item.id).text[listidx] = this.content
                    }
                } else if (item.tag === 'a') {
                    this.targetItems.find(el => el.id === item.id).text.text = this.content
                } else {
                    this.targetItems.find(el => el.id === item.id).text = this.content
                }
                this.content = ''
            }
        },
        saveChangesForTable(item, sth, idx) {
            if(sth === 'header') {
                this.targetItems.find(el => el.id === item.id).text["headers"][idx] = this.content
            } else {
                this.targetItems.find(el => el.id === item.id).text['rows'][sth][idx] = this.content
            }
        },
        saveInBuffer(item, event) {
            // Перший випадок каже, що це ul або ol
            if(item.tag === 'ul' || item.tag === 'ol') {
                this.content = event.target.textContent
            } else if(item.tag === 'code') {
                this.content = event.target.innerHTML
            } else {
                this.content = event.target.textContent ?
                event.target.textContent : event
            }
        },
        searchStyle(item) {
            if(
                (item.text === '' || item.text?.text === '') && 
                this.content === '' &&
                (item.tag !== 'code') &&
                (item.tag !== 'article')
            ) {
                return 'width: 100%; height: 25px; display: block; background-color: #efefef'
            }

            switch (item.tag) {
                case "h1":
                    return 'font-size: 32px; font-weight: bold; margin-bottom: 10px'
                case "h2":
                    return 'font-size: 28px; font-weight: bold; margin-bottom: 10px'
                case "h3":
                    return 'font-size: 24px; font-weight: bold; margin-bottom: 10px'
                case "h4":
                    return 'font-size: 18px; font-weight: bold; margin-bottom: 10px'
                case "h5":
                    return 'font-size: 16px; font-weight: bold; margin-bottom: 10px'
                case "h6":
                    return 'font-size: 14px; font-weight: bold; margin-bottom: 10px'
                case "p":
                    return 'font-size: 14px; margin-bottom: 10px'
                case 'ol':
                    return 'list-style-type: decimal; margin-left: 20px; margin-bottom: 10px; width: 100%'
                case 'ul':
                    return 'list-style-type: disc; margin-left: 20px; margin-bottom: 10px; width: 100%'
                case 'code':
                    return 'font-family: monospace; font-size: 14px; background-color: #292d3f; padding: 10px 20px; width: 100%; display: block; margin-bottom: 10px'
                case 'table':
                    return 'border-collapse: collapse; width: 100%; margin-bottom: 10px'
                case 'hr':
                    return 'width: 100%; color: gray'
            }
        },
        generateId() {
            return uuidv4()
        },
        onDragStart(item) {
            this.draggedItem = { ...item };
            if((item.tag === 'ul' || item.tag === 'ol') && item.text.length === 0) {
                this.draggedItem.text.push('')
            }
            this.isDragging = true; // Активуємо стан перетягування
            // console.log("Перетягування почалося:", item);
        },
        onDragEnd() {
            this.isDragging = false; // Деактивуємо стан перетягування
            // this.draggedItem = null;
            // console.log("Перетягування завершено");
        },
        onDrop(index) {
            let obj = {
                icon: this.draggedItem.icon,
                name: this.draggedItem.name,
                tag: this.draggedItem.tag,
                text: this.draggedItem.text,
                uuid: this.generateId()
            }

            if (this.withDropZones[index].isDropZone) {
                this.targetItems.splice(index / 2, 0, { ...obj });
                this.isDragging = false; // Скидання завершує перетягування
            }
        },
        onDragOver(index) {
            if (this.withDropZones[index].isDropZone) {
                // console.log("Наведення на зону скидання:", index);
            }
        }
    }
}
</script>

<style>
.row {
    top: 100%;
    left: calc(50% - 50px);
    width: 100px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
.column {
    top: 37%;
    left: 100%;
    height: 50%;
    max-height: 100px;
    border-top-right-radius: 10px;
    border-bottom-right-radius: 10px;
}
.tableButton {   
    position: absolute;
    border: none;
    color: rgb(95, 95, 95);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: visibility .3s ease;
}
.link_menu {
    position: absolute;
    z-index: 2;
    border: 1px solid gray;
    background-color: whitesmoke;
    border-radius: 10px;
}

.link_menu__header  {
    padding: 10px 20px;
    display: flex;
    align-items: end;
    justify-content: end;
    border-bottom: #000;
}

.link_menu__body{
    padding: 10px 20px;
}

.dropzoneCustom.dragover {
  border-color: #000;
  background-color: #eef;
}

.dropzoneCustom {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100px;
    border: 2px dashed #e9ebec;
    color: #7e7e7e
}

.upMenu{
    margin-bottom: 20px;
}

.container_custom {
    min-height: 80vh;
    max-height: 100%;
    overflow-y: auto;
    width: 100% !important;
    height: 100%;
    background: white;
    display: grid;
    grid-template-columns: 2fr 8fr 2fr;
    grid-template-rows: 1fr;
}

.doc_title:focus-visible, 
.drop-item > *:focus-visible, 
.li_focusVisisble,
.note__text:focus-visible {
    outline: none;
}

:is(.blocksMenu, .workspace) {
    padding: 32px;
}

.blocksMenu {
    overflow-y: scroll;
}

.blocksMenu__chooseMode {
    position: sticky;
}

.blocksMenu__chooseMode__switcher {
    display: flex;
    gap: 5px;
    font-size: 16px;
    text-align: center;
}

.content {
    position: sticky;
    padding: 32px 12px 32px 24px;
}

.drag-drop-container {
    font-family: Arial, sans-serif;
    margin: 0 auto;
    padding: 20px;
}
  
.zones {
    display: flex;
    gap: 20px;
    justify-content: center;
}
  
.source-zone,
.dropzone {
    width: 200px;
    min-height: 200px;
    border: 2px dashed #ccc;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
    background-color: #f9f9f9;
}
  
.source-zone h3,
.dropzone h3 {
    margin: 0;
    margin-bottom: 10px;
    text-align: center;
}
  
/* .drop-item {
    margin: 5px 0;
    background-color: #ddd;
    padding: 10px;
    border-radius: 5px;
    text-align: center;
    user-select: none;
} */
  
.drop-zone {
    background-color: #eef;
    border: 1px dashed #00f;
    min-height: 50px !important;
    margin: 5px 0;
    transition: opacity 0.3s ease;
}
  
.hidden {
    opacity: 0; /* Зони приховані, якщо перетягування не активне */
    pointer-events: none;
}

ul {
    list-style-type: none;
}

.list_blockMode {
    padding: 0;
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(50px, 1fr));
    gap: 10px
}

.item.blockMode {
    width: 50px;
    height: 50px;
    text-align: center;
}

.item-block{
    display: flex;
    flex-direction: column;
    width: 50px;
    height: 50px;
    border: 2px dashed #cbcbcb;
    border-radius: 10px;
    padding: 5px 10px;
    align-items: center;
    justify-content: center;
}

.item-block__icon {
    font-size: 24px;
    color: #cbcbcb
}
.note {
    margin-bottom: 10px;
    font-size: 16px;
}

.note__title {
    color: white;
    margin: 0;
    background-color: rgb(236 205 55);
    padding: 0 10px;
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.note__text {
    color: rgb(30, 30, 30);
    margin: 0;
    background-color: rgb(236 205 55 / 38%);
    font-size: 16px;
    padding: 10px;
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}
</style>